export default (string: string) => {
  return string.includes('data:image');
};
